import T from '../../common/components/T';

export const skeleton = () => {
    return [
        {
            row: [90, 10],
            items: [
                'empty',
                {
                    type: 'circle',
                    align: 'right',
                    diameter: 4
                }
            ],
            itemsStyles: {
                marginTop: '-16px'
            }
        },
        {
            type: 'title',
            width: 50,
            align: 'center'
        },
        'empty',
        {
            row: [50, 50],
            gap: 1,
            items: [
                {
                    type: 'blockLG'
                },
                {
                    content: [
                        {
                            type: 'text'
                        },
                        {
                            type: 'text'
                        }
                    ]
                }
            ]
        },
        {
            type: 'table',
            size: {
                rows: 6,
                columns: 4
            }
        }
    ];
};

export const gridThead = {
    data: [
        {
            type: 'active-row',
            name: 'activeRow'
        },
        {
            type: 'text',
            name: 'article',
            title: <T textName='article' defaultStr='Артикул' />,
            align: 'left'
        },
        {
            type: 'text',
            name: 'name',
            title: <T textName='name' defaultStr='Название' />,
            align: 'left'
        },
        {
            type: 'counter',
            name: 'count',
            title: <T textName='count' defaultStr='Кол-во' />
        },
        {
            type: 'text',
            name: 'scores',
            title: <T textName='scores-in-pv' defaultStr='Баллов, PV' />,
            align: 'left'
        }
    ]
};

export const createGridData = (data, initialData) => {
    const products = initialData?.products;

    return {
        ...data,
        data: data?.data?.map((product) => {
            const isActive = products?.find((item) => +item?.product?.id === +product.id);
            return {
                activeRow: isActive,
                article: product?.article || '-',
                name: product?.name || '-',
                count: isActive?.count || 1,
                scores: product?.price?.price_for_client,
                ...product
            };
        })
    };
};

export const handlers = (setInitValue, setGridData) => {
    const minusHandler = (rowData) => {
        console.log('rowData', rowData);
        let wasActive = false;
        setGridData((state) => ({
            ...state,
            tbody: {
                ...state.tbody,
                data: state.tbody.data.map((row) => {
                    if (row.id === rowData.id) {
                        if (row?.activeRow) wasActive = true;
                        return {
                            ...row,
                            count: +row.count === 0 ? 0 : +row.count - 1
                        };
                    }
                    return row;
                })
            }
        }));
        if (wasActive) {
            setInitValue((state) => ({
                ...state,
                products: state?.products?.map((product) => {
                    if (product.product.id === rowData?.id) {
                        return {
                            ...product,
                            count: +product?.count === 0 ? 0 : +product?.count - 1
                        };
                    }
                    return product;
                })
            }));
        }
    };

    const plusHandler = (rowData) => {
        let wasActive = false;
        setGridData((state) => ({
            ...state,
            tbody: {
                ...state.tbody,
                data: state.tbody.data.map((row) => {
                    if (row.id === rowData.id) {
                        if (row?.activeRow) wasActive = true;
                        return {
                            ...row,
                            count: +row.count + 1
                        };
                    }
                    return row;
                })
            }
        }));
        if (wasActive) {
            setInitValue((state) => ({
                ...state,
                products: state?.products?.map((product) => {
                    if (product.product.id === rowData?.id) {
                        return {
                            ...product,
                            count: +product?.count + 1
                        };
                    }
                    return product;
                })
            }));
        }
    };

    const rowHandler = (rowData) => {
        let wasActive = false;
        setGridData((state) => ({
            ...state,
            tbody: {
                ...state.tbody,
                data: state.tbody.data.map((row) => {
                    if (row.id === rowData.id) {
                        if (row?.activeRow) wasActive = true;
                        return {
                            ...row,
                            activeRow: !row?.activeRow
                        };
                    }
                    return row;
                })
            }
        }));
        if (wasActive) {
            setInitValue((state) => ({
                ...state,
                products: state?.products?.filter((product) => product?.product?.id !== rowData?.id)
            }));
        } else {
            setInitValue((state) => ({
                ...state,
                products: [...(state?.products || []), { count: rowData?.count, product: rowData }]
            }));
        }
    };

    return {
        activeRow: {
            change: {
                onChange: rowHandler
            }
        },
        count: {
            minus: {
                onClick: minusHandler
            },
            plus: {
                onClick: plusHandler
            }
        }
    };
};

export const transformSendData = (initValue) => {
    const newData = {};

    Object.keys(initValue || {}).forEach((key) => {
        switch (key) {
            case 'warehouse': {
                newData['warehouse_id'] = initValue['warehouse']['id'];
                break;
            }
            case 'products': {
                newData['products'] = initValue['products'].map((product) => {
                    return {
                        count: product.count,
                        id: product.product.id
                    };
                });
                break;
            }
            default: {
                newData[key] = initValue[key];
            }
        }
    });
    return newData;
};
